
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
    };
  },
  methods: {
    submitMainBanner() {
      store.dispatch("admin/uploadHomePageAboutUsMainBanner", {
        image: this.chosenFile,
      });
    },
    submitContent() {
      const data = {
        title: this.title,
        subTitle: this.subTitle,
        text: this.description,
        language: this.language,
      };
      store.dispatch("admin/submitHomePageAboutUsContent", data);
    },
    uploadMainBannerImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateMainBannerHomePageAboutUs",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    title: {
      get(): string {
        return store.state.admin.landing.homePage.aboutUs.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateHomePageAboutUsTitle", value);
      },
    },

    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    subTitle: {
      get(): string {
        return store.state.admin.landing.homePage.aboutUs.subTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateHomePageAboutUsSubTitle", value);
      },
    },

    subTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    language: {
      get(): string {
        return store.state.admin.landing.homePage.aboutUs.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateHomePageAboutUsLanguage", value);
      },
    },
    languageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.language?.$dirty) {
        return errors;
      }
      !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    description: {
      get(): string {
        return store.state.admin.landing.homePage.aboutUs.text;
      },
      set(value: string): void {
        store.dispatch("admin/updateHomePageAboutUsDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      store.dispatch("admin/updateProductCategory", id);
    }
  },
  validations: {
    title: {
      required,
    },
    subTitle: {
      required,
    },
    language: {
      required,
    },
    description: {
      required,
    },
  },
});
